import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import Flex from 'styled-flex-component'

import { SideBarBlock } from '@components/UI/SideBar'
import { ICampaignContextProps } from '@context/Campaign'
import { withCampaign } from '@hocs'
import { IApplicationState } from '@store'
import { selectIsCampaignFetched } from '@store/campaigns'
import { fetchMembers, IMember, selectAddMemberLink, selectMembers } from '@store/members'
import InboxMemberInvite from '../Invite/Invite'
import InboxMember from '../'

type IProps = ICampaignContextProps

export const InboxMemberList: React.FC<IProps> = ({ campaign }) => {
  const campaignId = campaign.id
  const dispatch = useDispatch()
  const isCampaignFetched = useSelector((state: IApplicationState) =>
    selectIsCampaignFetched(state, campaignId),
  )
  const members = useSelector((state: IApplicationState) => selectMembers(state, campaignId))
  const hasAddMemberLink = useSelector((state: IApplicationState) =>
    Boolean(selectAddMemberLink(state, campaignId)),
  )

  React.useEffect(() => {
    if (isCampaignFetched) {
      dispatch(fetchMembers(campaignId))
    }
  }, [isCampaignFetched, campaignId])

  return (
    <SideBarBlock
      header={
        <Flex justifyBetween>
          <FormattedMessage id="inbox.sidebar.members" />
          {hasAddMemberLink && <InboxMemberInvite />}
        </Flex>
      }
      items={members.map((member: IMember) => (
        <InboxMember key={member.id} member={member} campaignId={campaignId} />
      ))}
      elementName="side-bar-member"
    />
  )
}

export default withCampaign(InboxMemberList)
